import { defineStore, acceptHMRUpdate } from 'pinia'
import { STORAGE_KEYS } from '@/libs/utils/constants.ts'
import { deepCopyFn } from '@/libs/utils/data-jsFn'
export const usePermissionStore = defineStore({
  id: STORAGE_KEYS.PERMISSION_INFO,
  state: () => ({
    routes: [],
  }),
  getters: {
    getRoutes: state => {
      return state.routes || []
    },
  },
  actions: {
    async initRoutesAsync(data) {
      this.routes = data
    },
    // 根据key获取权限节点
    getCurrentRoute(name) {
      let obj = this.routes.find(e => e.componentName == name)
      return deepCopyFn(obj ?? {})
    },
  },
  // persist: {
  //   enabled: true,
  //   strategies: [
  //     {
  //       storage: localStorage, // $localStorage,
  //       paths: ['routes'], //可以选择保存的字段  其余的不保存
  //     },
  //   ],
  // },
})
